import { logCoreUsage } from 'owa-analytics';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { type UTGenericAction } from 'owa-unified-telemetry';
import type { UTActionDomain } from 'owa-unified-telemetry';
import getUnifiedTelemetryName from './getUnifiedTelemetryName';

export default function clickLogger(domain: UTActionDomain, e: MouseEvent): void {
    const target = e.target as Element;
    const { scope, name, idSource, origin, skipLog } = getUnifiedTelemetryName(target);
    // Using getGlobalSettingsAccountMailboxInfo: Generic click tracking is infrastructure telemetry
    // that captures UI interactions at the app level. The click target element doesn't have
    // account context, and this tracks aggregate user behavior patterns across the app.
    !skipLog &&
        logCoreUsage(
            'GenericAction', // Note: this can't be a dynamic value as we can't map a dynamic event into UT EventsMapping. Check eventsMapping.ts.
            getGlobalSettingsAccountMailboxInfo(),
            {
                domain,
                scope,
                name,
                action: 'Click',
                isAutoGenerated: true,
                idSource,
                origin,
            },
            {
                unifiedTelemetry: {
                    eventName: 'GenericAction',
                    data: {
                        ActionDomain: domain,
                        TargetScope: scope,
                        TargetName: name,
                        TargetAction: 'Click',
                        IdSource: idSource,
                        Origin: origin,
                    },
                },
            }
        );
}
